<template>
  <div>
    <div class="link-warp">
      <div
        :class="['link-item', { active: item.value === $route.path }]"
        v-for="item in navList"
        :key="item.value"
        @click="onClick(item.value)"
      >
        {{ item.label }}
      </div>
      <Button
        v-if="$route.path !== '/user/order'"
        class="goback btn-height45"
        to="/user/order"
        >返回</Button
      >
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "ordercontainer",
  data() {
    return {
      navList: [
        {
          active: true,
          value: "/user/order",
          label: "域名订单",
        },
      ],
    };
  },
  methods: {
    onClick(val) {
      this.$router.push(val);
    },
  },
};
</script>

<style lang="less" scoped>
.link-warp {
  background-color: #fff;
  padding: 0 30px;
  position: relative;
  .link-item {
    display: inline-block;
    height: 80px;
    line-height: 80px;
    margin: 0 30px;
    color: #333;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    &::before {
      width: 100%;
      background-color: #3992e9;
    }
  }
}
.main {
  margin: 50px 60px;
}
.goback {
  position: absolute;
  top: 50%;
  right: 60px;
  transform: translateY(-50%);
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
